import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 21 20'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M10.532 16.25q-2.618 0-4.434-1.816-1.815-1.815-1.816-4.433 0-2.616 1.816-4.434Q7.915 3.75 10.532 3.75q1.461 0 2.766.65a5.9 5.9 0 0 1 2.17 1.834V3.75h1.25v5.096h-5.096v-1.25h3.291a4.9 4.9 0 0 0-1.827-1.901A4.9 4.9 0 0 0 10.532 5Q8.448 5 6.99 6.458 5.532 7.917 5.532 10q0 2.084 1.458 3.542Q8.45 15 10.532 15q1.605 0 2.896-.917a4.84 4.84 0 0 0 1.812-2.416h1.318a6.1 6.1 0 0 1-2.235 3.311q-1.668 1.272-3.791 1.272'
    />
  </svg>
)
export default SvgComponent
